// frontend/src/utils/manualBoxLine.js
export function sessionDateForDays(days, now = new Date()) {
  const kstDate = new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Asia/Seoul',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);
  const date = new Date(`${kstDate}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() - 1 - days);
  return date.toISOString().slice(0, 10);
}

export function canRegisterManualLine(control, sessionDate, now = Date.now()) {
  return Boolean(
    control?.can_manage &&
    control.trading_open &&
    sessionDate === control.session_date &&
    now >= Date.parse(control.session_start) &&
    now < Date.parse(control.session_end),
  );
}

export function manualLinePayload(sessionDate, price, isTop) {
  return { session_date: sessionDate, close_box: Number(price), is_top: isTop };
}

export function manualLineDeleteDisabledReason(control, row) {
  if (!control?.can_manage)
    return '허용된 관리자만 삭제할 수 있습니다.';
  if (row.boxline_feature !== 'turning_point_manual')
    return '수동 입력 박스라인만 삭제할 수 있습니다.';
  if (row.strategy ? row.strategy.is_active : row.most_line)
    return '활성화된 라인은 삭제할 수 없습니다. 먼저 비활성화해 주세요.';
  if (row.strategy?.is_open)
    return '보유 포지션이 있는 라인은 삭제할 수 없습니다.';
  if (row.strategy?.busy)
    return '주문 처리·상태 확인이 끝난 후 다시 시도해 주세요.';
  if (row.strategy && !row.strategy.can_delete_line)
    return '현재 전략 상태에서는 라인을 삭제할 수 없습니다. 새로고침 후 다시 확인해 주세요.';
  return '';
}
